module.exports = __webpack_public_path__ + "img/05.a61192a9.png";